import React from 'react'
import { connect } from 'react-redux'
import { compose, lifecycle, withState } from 'recompose'
import { Field, reduxForm, getFormValues, FieldArray, reset } from 'redux-form'
import { 
  Form,
  TextArea,
  Button,
  Icon,
  Modal,
  Dropdown,
  Input } from  'semantic-ui-react'
import r from 'reactotron-react-js'

import { 
  Cont,} from './styled'
import {
  StdForm} from '../../../../../components'
import {
  renderFileDropzone
} from '../../../../Product/Shareds'
import {
  renderDropdown,
  renderTextArea,
  renderInput
} from './index'
import {DataCell} from '../DataCell'

const ChatModal = (props) => {
  const {
    prDetail,
    handleSubmit
  } = props
  return (
    <Form onSubmit={handleSubmit(submitChat)}>
      <Modal open={props.open} size='tiny'>
        <Modal.Header>Approval Chat</Modal.Header>
        <Modal.Content>
          <div className='ui form' style={{display:'flex',flexDirection:'column'}}>
            <div style={{fontWeight:'bold'}}>Your Question</div>
            <Field name="comment" component={renderTextArea}/> 
            <div style={{flex:1,display:'flex',marginTop:'1rem'}}>
              <div style={{flex:1,display:'flex',flexDirection:'column'}}>
                <div style={{fontWeight:'bold'}}>Responsibility</div>
                <Field label="Email" name="emailSelect" component={renderDropdown} option={props.prEmailLoop}/>
              </div>
              <div style={{marginLeft:'1rem',flex:1,display:'flex',flexDirection:'column'}}>
                <div style={{fontWeight:'bold'}}>Or Email</div>
                <Field name="emailInput" component={renderInput} />
              </div>
            </div>
            <Field 
              name='attachFile' 
              title='Attachment' 
              multiple={false} 
              documentType={0}
              component={renderFileDropzone} />
          </div>
        </Modal.Content>
        <Modal.Actions>
          <Button color='yellow' onClick={props.onCloseClick}>
            <Icon name='remove' /> Cancel
          </Button>
          <Button color='green'>
            <Icon name='checkmark' /> Send
          </Button>
        </Modal.Actions>
      </Modal>
    </Form>
  )

  function submitChat(){
  }
}

const mapStateToProps = (state) => {
  return ({
    initialValues: {
      comment:'',
      emailSelect:'',
      emailInput:'',
      attachFile:''
    },
    valueForm: getFormValues('formPRApprovalChat')(state),
    prEmailLoop: state.pr.prEmailLoop,
    prDetail: state.pr.prDetail
  })
}
const mapDispatchToProps = {
  
}

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  connect((state, props) => ({
    history: props.history
  })),
  reduxForm({
    form: 'formPRApprovalChat',
    enableReinitialize: true
  }),
  lifecycle({
    componentDidMount() {
     
    },
    componentWillReceiveProps(nextProp) {
      
    }
  })
)

export default enhance(ChatModal)
